'use strict';
 /**
 * @author Maxim Seredkin
 */
export default ['$resource',
    function ($resource) {
        return $resource('api/investor-countries/:investorCountryId', null, {
            getAll: {method: 'GET'},
            get: {method: 'GET'},
            create: {method: 'POST'},
            update: {method: 'PUT'},
            remove: {method: 'DELETE'},
            enable: {url: 'api/investor-countries/:investorCountryId/enable', method: 'PUT'},
            delete: {url: 'api/investor-countries/:investorCountryId/delete', method: 'PUT'},
            getDefault: {url: 'api/investor-countries/default', method: 'GET'},
            setDefault: {url: 'api/investor-countries/:investorCountryId/default', method: 'PUT'},
            isUniqueName: {url: 'api/investor-countries/unique/name/:name', method: 'GET'}
        });
    }];